module.exports = __webpack_public_path__ + "img/moon.dc13dc58.png";